module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-padding"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "carousel-headline"
  }, [_vm._v("Unsere Filme zum Thema Bahnnostalgie")]), _vm._v(" "), _c('bahnnostalgie-movies-list')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "visual"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 550px)",
      "srcset": "img/visual-bahnnostalgie.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "img/visual-bahnnostalgie-small.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('h1', [_vm._v("Bahnnostalgie")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d153b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bahnnostalgie.vue
// module id = 77
// module chunks = 0